export default __webpack_public_path__ + "static/steam-06edf73ae6cab658ac6b2d1a65ac3a70.png";